import {
  TransactionActionType,
  GetTransactionDataStartAction,
  GetTransactionDataSuccessAction,
  GetTransactionDataFailureAction,
  CancelHostedTransactionAction
} from './transaction.actions';
import { createReducer } from '@common/redux-utils';
import { HostedCheckoutTransactionViewModel } from '@models/HostedCheckoutTransactionViewModel';
import { SetTransactionLandingPageLoadingAction } from './transaction.actions';
import {
  CopyCardToAccountLoadingAction as SetCopyCardToAccountLoadingAction,
  CopyCardToAccountSuccessAction
} from './transaction.actions';

// Defining the state of the page.
// Should be one per page.
// All properties should be readonly.
export interface HostedTransactionState {
  readonly transactionId: number;
  readonly message: string;
  readonly transactionDataLoading?: boolean;
  readonly transactionPageLoading: boolean;
  readonly data?: HostedCheckoutTransactionViewModel;
  readonly copyCardIsLoading?: boolean;
}

// This is the initial state of the page
export const initialHostedTransactionState: HostedTransactionState = {
  transactionId: 0,
  message: '',
  transactionDataLoading: false,
  copyCardIsLoading: false,
  transactionPageLoading: true
};

/********** Fetch **********/
function handleGetTransactionDataStart(
  state: HostedTransactionState,
  action: GetTransactionDataStartAction
): HostedTransactionState {
  return {
    ...state,
    message: 'Fetch Init',
    transactionId: action.transactionId,
    transactionDataLoading: true
  };
}

function handleGetTransactionDataSuccess(
  state: HostedTransactionState,
  action: GetTransactionDataSuccessAction
): HostedTransactionState {
  return {
    ...state,
    message: 'Load Success!',
    transactionDataLoading: false,
    data: action.result
  };
}

function handleGetTransactionDataFailure(
  state: HostedTransactionState,
  action: GetTransactionDataFailureAction
): HostedTransactionState {
  return {
    ...state,
    message: action.errorMessage,
    transactionDataLoading: false
  };
}

function handleSetTransactionCopyCardToAccountLoading(
  state: HostedTransactionState,
  action: SetCopyCardToAccountLoadingAction
): HostedTransactionState {
  return {
    ...state,
    copyCardIsLoading: action.isLoading
  };
}

function handleTransactionCopyCardToAccountSuccess(
  state: HostedTransactionState,
  action: CopyCardToAccountSuccessAction
): HostedTransactionState {
  return {
    ...state
  };
}

function handleCancelHostedTransaction(
  state: HostedTransactionState,
  action: CancelHostedTransactionAction
): HostedTransactionState {
  return {
    ...state
  };
}

function handleSetTransactionLandingPageLoading(
  state: HostedTransactionState,
  action: SetTransactionLandingPageLoadingAction
): HostedTransactionState {
  return {
    ...state,
    transactionPageLoading: action.isLoading
  };
}

function handleResetTransactionState(
  state: HostedTransactionState,
  action: SetTransactionLandingPageLoadingAction
): HostedTransactionState {
  return {
    ...initialHostedTransactionState
  };
}

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
export const TransactionDataReducer = createReducer<HostedTransactionState, TransactionActionType>(
  initialHostedTransactionState,
  {
    /********** Search **********/
    [TransactionActionType.GetTransactionDataStart]: handleGetTransactionDataStart,
    [TransactionActionType.GetTransactionDataSuccess]: handleGetTransactionDataSuccess,
    [TransactionActionType.GetTransactionDataFailure]: handleGetTransactionDataFailure,
    [TransactionActionType.SetCopyCardToAccountLoading]: handleSetTransactionCopyCardToAccountLoading,
    [TransactionActionType.CopyCardToAccountSuccess]: handleTransactionCopyCardToAccountSuccess,
    [TransactionActionType.CancelHostedTransaction]: handleCancelHostedTransaction,
    [TransactionActionType.SetTransactionLandingPageLoading]: handleSetTransactionLandingPageLoading,
    [TransactionActionType.ResetTransactionState]: handleResetTransactionState
  }
);



// WEBPACK FOOTER //
// ./src/transaction/transaction.reducer.ts